// extracted by mini-css-extract-plugin
module.exports = {"dot":"ActiveDot_dot__Jbacq","active":"ActiveDot_active__1jbmw","inactive":"ActiveDot_inactive__DLcvM"};